import { del } from './client';
import { buildPath } from './utils';
import { ADMIN_USER_ROLES } from './constants';
import { IdType, Options } from './types';

export const removeAdminUserRole = (id: IdType, options: Options) => del(buildPath(ADMIN_USER_ROLES, id), options);
